import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Smartphone, Battery, Usb, Droplets, Camera, Speaker, Clock } from "lucide-react";

const SERVICES = [
  { key: "screen", Icon: Smartphone, title: "Remplacement écran", description: "Écran fissuré ou cassé ? Remplacement avec pièces de qualité.", price: "À partir de 59€", duration: "30-60 min", popular: true },
  { key: "battery", Icon: Battery, title: "Changement batterie", description: "Batterie qui ne tient plus ? Retrouvez une autonomie optimale.", price: "À partir de 49€", duration: "20-30 min", popular: true },
  { key: "connector", Icon: Usb, title: "Réparation connecteur", description: "Port de charge défaillant ? Nous le réparons ou remplaçons.", price: "À partir de 55€", duration: "30-45 min", popular: false },
  { key: "water", Icon: Droplets, title: "Désoxydation", description: "Téléphone tombé dans l'eau ? Intervention d'urgence possible.", price: "À partir de 69€", duration: "24-48h", popular: false },
  { key: "camera", Icon: Camera, title: "Réparation caméra", description: "Caméra floue ou défectueuse ? Remplacement rapide.", price: "À partir de 65€", duration: "30-45 min", popular: false },
  { key: "audio", Icon: Speaker, title: "Haut-parleur / Micro", description: "Problème de son ? Nous réparons tous les composants audio.", price: "À partir de 55€", duration: "30-45 min", popular: false },
];

export const RepairServicesGrid = () => (
  <section className="section-padding bg-slate-50">
    <div className="container-custom">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Nos interventions</h2>
        <p className="text-lg text-slate-600">Diagnostic gratuit • Intervention rapide • Garantie incluse</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((service) => (
          <Card key={service.key} className="relative overflow-hidden hover:shadow-lg transition-shadow border-slate-200">
            {service.popular && (
              <div className="absolute top-3 right-3">
                <Badge className="bg-red-600 text-white text-xs hover:bg-red-600">Populaire</Badge>
              </div>
            )}
            <CardContent className="p-6">
              <div className="w-14 h-14 rounded-xl bg-red-100 flex items-center justify-center mb-4">
                <service.Icon className="h-7 w-7 text-red-600" />
              </div>
              <h3 className="font-bold text-lg text-slate-900 mb-2">{service.title}</h3>
              <p className="text-slate-600 text-sm mb-4">{service.description}</p>
              <div className="flex items-center justify-between pt-4 border-t border-slate-100">
                <span className="font-bold text-red-600">{service.price}</span>
                <span className="text-sm text-slate-500 flex items-center gap-1">
                  <Clock className="h-4 w-4" />
                  {service.duration}
                </span>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);
